export default "__VITE_ASSET__medPlCnK__"